import React, { FC, useEffect, useRef, useState } from 'react'
import AccountLinksDropDown from './AccountLinksDropDown'
import styles from './Account.module.scss'
import classNames from 'classnames'
import { useHeaderContext } from '../../HeaderContext'
import { useSelector } from 'react-redux'
import { getCheckIsMobileScreenWidth } from 'selectors/screen'
import { getUserInitials } from 'selectors/user/session'
import { MAX_NAVBAR_MOBILE_WIDTH } from '../../navBreakpoints'

// Module scope so the memoized selector is created once
const getIsNavbarMobileWidth = getCheckIsMobileScreenWidth(MAX_NAVBAR_MOBILE_WIDTH)

const Account: FC = () => {
  const userInitials = useSelector(getUserInitials)
  const isMobileScreenWidth = useSelector(getIsNavbarMobileWidth)
  const { setMobileHeaderConfig } = useHeaderContext()
  const [dropdownIsOpen, handleDropdownOpen] = useState<boolean>(false)
  const [dropdownIsHovered, setDropdownIsHovered] = useState<boolean>(false)
  const accountRef = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    setDropdownIsHovered(false)

    // On mobile the links render inside the menu overlay instead of this dropdown
    if (!isMobileScreenWidth) {
      handleDropdownOpen((prevState) => !prevState)
      return
    }

    setMobileHeaderConfig((previousMobileHeaderConfig) => ({
      ...previousMobileHeaderConfig,
      mobileMenuContent: 'user',
      mobileTopHeader: 'user',
      isMobileMenuOpen: true,
    }))
  }

  const handleDropdownHovered = (booleanFlag) => {
    return () => {
      if (!isMobileScreenWidth) {
        setDropdownIsHovered(booleanFlag)
      }
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        handleDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div
      className={styles.accountDropDownMenu}
      onMouseOver={handleDropdownHovered(true)}
      onMouseLeave={handleDropdownHovered(false)}
      onFocus={handleDropdownHovered(true)}
      onBlur={handleDropdownHovered(false)}
      data-type='account-icon'
      ref={accountRef}
    >
      <button
        type='button'
        aria-label='authentication links'
        className={classNames(styles.accountIcon, {
          [styles.accountIconMobile]: isMobileScreenWidth,
        })}
        onClick={handleClick}
        data-type={`account-initials${isMobileScreenWidth ? '-mobile' : ''}`}
      >
        <span className={styles.accountIconInitials}>{userInitials}</span>
      </button>
      <AccountLinksDropDown dropdownIsOpen={dropdownIsOpen} dropdownIsHovered={dropdownIsHovered} />
    </div>
  )
}

export default Account
